import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import ThicknessClassName from "../../components/thicknessClass/ThicknessClassDetail/ThicknessClassName.tsx";
import {useLocationFormState} from "../../components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateForm";
import ThicknessClassUpdateFormProvider from "../../components/thicknessClass/ThicknessClassForm/ThicknessClassUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ThicknessClassUpdateEditPage = () => {
    
    useTitle(t`Update Thickness Class`);

    const { thicknessClassId: id } = useParams();
    
    return (
        <Box data-testid="ThicknessClass-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="ThicknessClass-update-title"
                    >
                        <Trans>Edit Thickness Class</Trans>:  <ThicknessClassName id={id}/>
                    </Typography>
                    <ThicknessClassUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default ThicknessClassUpdateEditPage;
